exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tour-page {\n  margin-bottom: 40px; }\n\n.poster-list {\n  display: flex;\n  max-width: 100%;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 20px; }\n\n.poster-list img {\n  flex: 1;\n  max-width: 32%;\n  border: 2px solid white;\n  border-radius: 15px; }\n\n@media (max-width: 768px) {\n  .poster-list {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%; }\n  .poster-list img {\n    max-width: 100%;\n    flex: 1;\n    align-self: stretch; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/views/tour-page/tour-page.scss
// module id = 375
// module chunks = 0